import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiDialog from "components/Custom/UiDialog";

import { COMMON_JS } from "common/scripts";
import { DEFAULTS, FORMATS, NOTIFY } from "common/config";
import { DateFunctions } from "common/datefunctions";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/lables";

import { MASTER_APIs } from "apihandlers/master";
import { USER_APIs } from "apihandlers/user";
import Area from "components/Masters/Area";
import { GEO_APIs } from "apihandlers/geography";
import { PRODUCT_APIs } from "apihandlers/product";

const SchemeToolkit = (props: any) => {
  const { setDashMenu } = props;

  const model = [
    {
      id: "Scheme Engine Sep22 v1",
      label: "Scheme Engine Sep22 v1",
    },
    {
      id: "Scheme Engine Sep22 v2",
      label: "Scheme Engine Sep22 v2",
    },
  ];

  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [mandatoryLoadResults, setMandatoryLoadResults] = useState<any[]>([]);

  // const [model, setUsers] = useState([]);
  const [product, setProduct] = useState([]);
  const [scheme, setScheme] = useState<any>(
    selectedRow.messages ? selectedRow.messages : []
  );

  const modelRef: any = useRef(null);
  const productRef: any = useRef(null);
  const schemeRef: any = useRef(null);
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "state",
      name: LABELS.STATE,
      width: "25%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "sold",
      name: LABELS.SOLD,
      width: "25%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "expected",
      name: LABELS.EXPECTED,
      width: "25%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "burn",
      name: LABELS.BURN,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
  ];

  useEffect(() => {
    if (loading) {
      getProducts();
    }
  }, [loading]);

  const getProducts = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    PRODUCT_APIs.getProductsSku(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.productName,
          };
        });
        setProduct(list);
        getSchemes();
        // getRows();
      }
    });
  };
  const getSchemes = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    MASTER_APIs.getSchemes(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.schemeNo,
          };
        });
        setScheme(list);
        // getRows();
      }
    });
  };
  // const getRows = () => {
  //   const args = {
  //     pageNo: 1,
  //     pageLength: DEFAULTS.PAGE_LENGTH,
  //   };
  //   MASTER_APIs.getVehicleChecks(args).then((res: any) => {
  //     const response: any = res.response;
  //     const { status } = res;
  //     if (status === 200) {
  //       let list = response.records;
  //       for (let i = 0; i < list.length; i++) {
  //         list[i]["slNo"] = i + 1;
  //         if (list[i]["activeStatus"]) {
  //           list[i]["activeStatus"] = "Yes";
  //         } else {
  //           list[i]["activeStatus"] = "No";
  //         }
  //       }
  //       setRows(list);
  //       setLoading(false);
  //     }
  //   });
  // };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const getRows = () => {
    const model = modelRef.current.selectedValue.id;
    const product = productRef.current.selectedValue.id;
    const scheme = schemeRef.current.selectedValue.id;

    let loadErrors = [];

    if (!model) {
      loadErrors.push({
        id: "model",
        msg:
          "<span class='bold'>" +
          LABELS.MODEL +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!product) {
      loadErrors.push({
        id: "product",
        msg:
          "<span class='bold'>" +
          LABELS.PRODUCT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!scheme) {
      loadErrors.push({
        id: "scheme",
        msg:
          "<span class='bold'>" +
          LABELS.SCHEME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryLoadResults(loadErrors);
    if (loadErrors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      model,
      product,
      scheme,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    console.log("Args", args);
    MASTER_APIs.getSchemeToolkit(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setRows(list);
        setLoading(true);
      }
    });
  };

  console.log("Page: Country:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>
            {LABELS.TRANSACTION}{" "}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.SCHEME_TOOLKIT}</li>
        </ul>
        <h4>{TITLES.SCHEME_TOOLKIT}</h4>
        <p>{SUB_TITLES.SCHEME_TOOLKIT}</p>
      </div>
      <div className=" flexRowJustify width70">
        <div className="formGroup width25 required">
          <label>{LABELS.MODEL}</label>
          <span className="red">{" *"}</span>
          <AutoComplete id={"model"} list={model} childRef={modelRef} />
        </div>

        <div className="formGroup width25 required ">
          <label>{LABELS.PRODUCT}</label>
          <span className="red">{" *"}</span>

          <AutoComplete
            id={"product"}
            list={product}
            childRef={productRef}
            // defaultValue={{ id: "-1", label: "Select Month" }}
            onChange={() => {
              setLoading(true);
            }}
          />
        </div>
        <div className="formGroup width25 required ">
          <label>{LABELS.SCHEME}</label>
          <span className="red">{" *"}</span>

          <AutoComplete
            id={"scheme"}
            list={scheme}
            childRef={schemeRef}
            // defaultValue={{ id: "-1", label: "Select Month" }}
            onChange={() => {
              setLoading(true);
            }}
          />
        </div>
        <div
          style={{
            padding: "1.5rem 0rem 3rem 0rem",
          }}
        >
          <Btn
            text={LABELS.TEST}
            onClick={getRows}
            bgColor={COLORS.SAVE_GREEN}
          />
        </div>
      </div>
      {/* mandatoryResults */}
      {mandatoryLoadResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryLoadResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className="grid excelGridWrapper">
        {loading === true ? (
          rows && (
            <ExcelGrid
              id={"schemeToolkit"}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={LABELS.SCHEME_TOOLKIT}
              onReload={reloadGrid}
            />
            // ) : (
            //   <div className="flexRowCenter">
            //     <Loader />s
            //   </div>
          )
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default withSnackbar(SchemeToolkit);
